import React from "react";
import { Link } from "react-router-dom";

export default function Banner() {
    return (
        <section>
            <div className="container">
                <div className="s-banner-countdown banner-cd-fashion">
                    <div className="image">
                        <img
                            src="/images/banner/fashion-1.jpg"
                            data-=""
                            alt=""
                            className="lazyload"
                            width={1440}
                            height={488}
                        />
                    </div>
                    <div className="banner-content text-center">
                        <p className="season text-md fw-medium">LUX & CO</p>
                        <h2 className="fw-medium">Own the Moment</h2>
                        <p className="sub text-md fw-medium">Explore wardrobe staples that speak style and substance.</p>
                        <div className="box-btn wow fadeInUp">
                            <Link
                                to={`/product-list`}
                                className="tf-btn btn-white hover-primary"
                            >
                                Shop Now
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}
